import _ from 'lodash';

import { RESET_STATE } from 'store/global/actions';

import { TPO_DENIAL_CONFIGURATION_ACTION_TYPE } from '../actions';

const initialState = {
  categories: [],
};

const updateCategory = (state, categoryId, update) => ({
  ...state,
  categories: state.categories.map(category =>
    category.tpoDenialCategoryId === categoryId ? update(category) : category,
  ),
});

const tpoDenialConfigurationReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case TPO_DENIAL_CONFIGURATION_ACTION_TYPE.GET_CATEGORIES:
      return { ...state, categories: Array.isArray(payload) ? payload : [] };

    case TPO_DENIAL_CONFIGURATION_ACTION_TYPE.CREATE_CATEGORY:
      return { ...state, categories: [...state.categories, { reasons: [], ...payload }] };

    case TPO_DENIAL_CONFIGURATION_ACTION_TYPE.UPDATE_CATEGORY:
      return updateCategory(state, payload.tpoDenialCategoryId, category => ({
        ...category,
        ..._.omit(payload, 'reasons'),
      }));

    case TPO_DENIAL_CONFIGURATION_ACTION_TYPE.DELETE_CATEGORY:
      return {
        ...state,
        categories: state.categories.filter(
          ({ tpoDenialCategoryId }) => tpoDenialCategoryId !== payload.categoryId,
        ),
      };

    case TPO_DENIAL_CONFIGURATION_ACTION_TYPE.CREATE_REASON:
      return updateCategory(state, payload.tpoDenialCategoryId, category => ({
        ...category,
        reasons: [...category.reasons, payload],
      }));

    case TPO_DENIAL_CONFIGURATION_ACTION_TYPE.UPDATE_REASON:
      return updateCategory(state, payload.tpoDenialCategoryId, category => ({
        ...category,
        reasons: category.reasons.map(reason =>
          reason.tpoDenialReasonId === payload.tpoDenialReasonId ? payload : reason,
        ),
      }));

    case TPO_DENIAL_CONFIGURATION_ACTION_TYPE.DELETE_REASON:
      return updateCategory(state, payload.categoryId, category => ({
        ...category,
        reasons: category.reasons.filter(
          ({ tpoDenialReasonId }) => tpoDenialReasonId !== payload.reasonId,
        ),
      }));

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default tpoDenialConfigurationReducer;
